import React from "react";
import "../styles/AdaptiveCard.scss";
import { useNavigate } from "react-router-dom";

const AdaptiveCard = ({
  title,
  breadcrumb,
  status = "active",
  onClick,
  link,
  onCtaClick,
  cardType,
  completed = false,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={`adaptive-card `} onClick={handleClick}>
      <div className="card-breadcrumb">{breadcrumb}</div>
      <div className="card-badges">
        <div className="card-topic-badge">Topic</div>
        {completed ? (
          <div className="card-completed-badge">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: "4px" }}
            >
              <path
                d="M7 0C3.13 0 0 3.13 0 7C0 10.87 3.13 14 7 14C10.87 14 14 10.87 14 7C14 3.13 10.87 0 7 0ZM5.6 10.5L2.1 7L3.22 5.88L5.6 8.26L10.78 3.08L11.9 4.2L5.6 10.5Z"
                fill="currentColor"
              />
            </svg>
            Completed
          </div>
        ) : (
          cardType === "active-recall" && (
            <div className="card-not-completed-badge">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginRight: "4px" }}
              >
                <path
                  d="M7 0C3.13 0 0 3.13 0 7C0 10.87 3.13 14 7 14C10.87 14 14 10.87 14 7C14 3.13 10.87 0 7 0ZM10.5 9.5L9.5 10.5L7 8L4.5 10.5L3.5 9.5L6 7L3.5 4.5L4.5 3.5L7 6L9.5 3.5L10.5 4.5L8 7L10.5 9.5Z"
                  fill="currentColor"
                />
              </svg>
              Not Completed
            </div>
          )
        )}
      </div>
      <div className="card-title">{title}</div>
      <div className="card-footer">
        <div className={`card-status ${status}`}>{status}</div>
        <div
          className={`card-cta ${status}`}
          onClick={(event) => {
            event.stopPropagation();
            if (cardType === "active-recall" && link) {
              navigate(`/courses/${link}`);
              return;
            } else {
              if (onCtaClick) {
                onCtaClick();
                return;
              }
            }
          }}
        >
          Try Now →
        </div>
      </div>
    </div>
  );
};

export default AdaptiveCard;
